/* =============================================================================
   FEBU — keep the subscription plan in step with quantity in the cart drawer.

   Pricing model: one Appstle selling plan group per quantity tier
   (1 / 2 / 3 / 4+ units), each with one plan per frequency ("1 Month" ...
   "6 Months"). The discount lives on the plan, so when a shopper changes the
   quantity of a subscription line in the cart, the line must move to the plan
   of the matching tier with the same frequency. This script does exactly that,
   once, as part of the same quantity update the theme already sends
   (cart-element.updateCart supports a selling_plan field). No polling, no
   price patching — Shopify prices the line from the new plan.

   Loaded from snippets/head.liquid. Relies on cart-line-items.liquid marking
   subscription lines with data-febu-subscription-item and data-febu-current-plan.
   ============================================================================= */
(function () {
  'use strict';

  var productCache = {};

  function unitsOf(name) {
    var m = String(name || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  /* Month count of a plan: first number in its name ("2 Months", "Every 2 months");
     a name with no number ("Monthly Subscription") counts as 1. */
  function monthsOf(name) {
    var m = String(name || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 1;
  }

  /* Tiers in unit order (one per distinct unit count; first group wins on a tie).
     Falls back to source order if names carry no number. */
  function buildTiers(product) {
    var groups = (product && product.selling_plan_groups) ? product.selling_plan_groups.slice() : [];
    var named = groups.filter(function (g) { return unitsOf(g.name) > 0; });
    named.sort(function (a, b) { return unitsOf(a.name) - unitsOf(b.name); });
    var seen = {};
    named = named.filter(function (g) { var u = unitsOf(g.name); if (seen[u]) return false; seen[u] = true; return true; });
    var list = named.length ? named : groups;
    return list.map(function (g) {
      var plans = {};
      g.selling_plans.forEach(function (p) { plans[monthsOf(p.name)] = String(p.id); });
      return { plans: plans, ids: g.selling_plans.map(function (p) { return String(p.id); }) };
    });
  }

  function monthsOfPlan(tiers, planId) {
    for (var i = 0; i < tiers.length; i++) {
      for (var months in tiers[i].plans) {
        if (tiers[i].plans[months] === String(planId)) return months;
      }
    }
    return null;
  }

  function productForItem(item) {
    var link = item.querySelector('a[href*="/products/"]');
    var m = link && (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (!m) return Promise.resolve(null);
    var handle = m[1];
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  document.addEventListener('theme:cart:update', function (e) {
    if (!e.detail || !e.target || typeof e.target.closest !== 'function') return;
    var item = e.target.closest('[data-febu-subscription-item]');
    if (!item) return;

    var qty = parseInt(e.detail.quantity, 10);
    if (!qty || qty < 1) return; /* removal — let the theme handle it */

    var currentPlan = item.getAttribute('data-febu-current-plan');
    var cartEl = document.querySelector('cart-element');
    if (!currentPlan || !cartEl || typeof cartEl.updateCart !== 'function') return;

    /* Take over this update so the plan change rides along with the quantity. */
    e.stopPropagation();

    productForItem(item).then(function (product) {
      var tiers = buildTiers(product);
      var newPlan = currentPlan;
      if (tiers.length) {
        var tier = tiers[Math.min(Math.max(qty, 1), tiers.length) - 1];
        var months = monthsOfPlan(tiers, currentPlan);
        var candidate = (months && tier.plans[months]) || tier.ids[0];
        if (candidate) newPlan = String(candidate);
      }
      var data = { id: e.detail.id, quantity: qty };
      if (newPlan !== currentPlan) data.selling_plan = newPlan;
      cartEl.updateCart(data, item);
    });
  }, true);
})();